import React from 'react';
import './Card.css';

const Card = ({ cardData, isFlipped, isFlashing, onClick, isMatched }) => {
  const handleClick = () => {
    if (!isFlipped && !isMatched) {
      onClick(cardData);
    }
  };

  const shouldFlip = isFlipped || isMatched || isFlashing;

  return (
    <div 
      className={`card ${shouldFlip ? 'flipped' : ''} ${isMatched ? 'matched' : ''}`}
      onClick={handleClick}
    >
      <div className="card-inner">
        {/* Facetas de cantos low-poly */}
        <div className="card-hex-edge top"></div>
        <div className="card-hex-edge bottom"></div>

        {/* Verso da carta (costas visíveis antes de virar - Card Back) */}
        <div className="card-front">
          <div className="card-pattern">
            <div className="adinkra-card-symbol">
              <svg viewBox="0 0 36 36" width="32" height="32" fill="none" stroke="currentColor" strokeWidth="2.2">
                <circle cx="18" cy="18" r="14" stroke="#d4af37" strokeOpacity="0.8"/>
                <polygon points="18 6 24 14 18 22 12 14" fill="#00e5ff" fillOpacity="0.25" stroke="#00e5ff"/>
                <polygon points="18 30 24 22 18 14 12 22" fill="#00e5ff" fillOpacity="0.25" stroke="#00e5ff"/>
                <circle cx="18" cy="18" r="3" fill="#ffc83b"/>
              </svg>
            </div>
          </div>
        </div>

        {/* Frente da carta (conteúdo revelado ao virar - Card Front) */}
        <div className={`card-back ${cardData.type === 'foto' ? 'card-foto' : 'card-nome'}`}>
          {cardData.type === 'foto' ? (
            typeof cardData.content === 'object' && 
            cardData.content !== null && 
            cardData.content.src && 
            cardData.content.srcset ? (
              <div className="foto-content">
                <div className="foto-portal-wrapper">
                  <picture style={{ width: '100%', height: '100%', display: 'block' }}>
                    <source srcSet={cardData.content.srcset} sizes={cardData.content.sizes} />
                    <img 
                      src={cardData.content.src}
                      alt="Imortal"
                      className="foto-img"
                      loading="lazy"
                      onError={(e) => {
                        console.error(`❌ Erro ao carregar imagem do Firebase Storage:`, cardData.content.src);
                        e.target.style.display = 'none';
                      }}
                    />
                  </picture>
                </div>
                <div className="foto-overlay"></div>
                <div className="foto-hex-border"></div>
              </div>
            ) : null
          ) : (
            <div className="nome-content">
              <div className="nome-hex-border"></div>
              <h2>{cardData.content}</h2>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Card;
